module.exports = __webpack_public_path__ + "static/img/brand-06.4955d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-06.png
// module id = sZLQ
// module chunks = 0